import { render, staticRenderFns } from "./ClientCabin.vue?vue&type=template&id=c906a786&"
import script from "./ClientCabin.vue?vue&type=script&lang=ts&"
export * from "./ClientCabin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports